// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"social-friend-list_wrapper__1JQFY"};